// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import blackList from './metaData/blackList'
export default {
  state: blackList,
  actions
}
